import { render, staticRenderFns } from "./Detay.vue?vue&type=template&id=488ed1c8&"
import script from "./Detay.vue?vue&type=script&lang=js&"
export * from "./Detay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports